"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.populateDuplicateCounts = exports.populateModerationNotes = exports.fetchAndPopulateItem = exports.getAvailableQueues = exports.populateJobDetails = void 0;
/* eslint-disable no-param-reassign */
var apiService_1 = __importDefault(require("@common/services/apiService"));
var job_1 = __importDefault(require("@common/model/job"));
var getCurrentQueueNameAndId_1 = require("@utils/getCurrentQueueNameAndId");
var util_1 = require("@features/ItemCommon/service/util");
var duplicateAdsCount_1 = require("@features/ItemCommon/service/duplicateAdsCount");
var moderationNotes_1 = require("@features/ItemCommon/service/moderationNotes");
function populateJobDetails(domain, job, currentQueueName) {
    return __awaiter(this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, populateModerationNotes(domain, job, currentQueueName)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, populateDuplicateCounts(domain, job)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error('Error populating job details', e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.populateJobDetails = populateJobDetails;
var getAvailableQueues = function (job, status, allQueuesData) {
    var _a, _b;
    if (['reviewable', 'deferred'].includes(status) && ((_a = job === null || job === void 0 ? void 0 : job.ad) === null || _a === void 0 ? void 0 : _a.history[0])) {
        var _c = __read((0, getCurrentQueueNameAndId_1.getCurrentQueueNameAndId)((_b = job === null || job === void 0 ? void 0 : job.ad) === null || _b === void 0 ? void 0 : _b.history[0], allQueuesData), 2), currentQueueName = _c[0], currentQueueId_1 = _c[1];
        return {
            availableQueues: allQueuesData.filter(function (q) { return !(q.id === currentQueueId_1); }),
            currentQueueId: currentQueueId_1,
            currentQueueName: currentQueueName,
        };
    }
    return {
        availableQueues: allQueuesData,
        currentQueueId: undefined,
        currentQueueName: undefined,
    };
};
exports.getAvailableQueues = getAvailableQueues;
function fetchAndPopulateItem(domain, itemId, queues, feedbackSetArray, isPostReviewEnabled) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var res, item, job, status_1, _d, availableQueues, currentQueueId, currentQueueName, jobDetailPromise, ex_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService_1.default.getItem({ domain: domain, itemId: itemId })];
                case 1:
                    res = _e.sent();
                    item = res.data;
                    job = new job_1.default(item);
                    status_1 = (_c = (_b = (_a = job.ad) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.meta) === null || _c === void 0 ? void 0 : _c.status;
                    _d = (0, exports.getAvailableQueues)(job, status_1 || '', queues), availableQueues = _d.availableQueues, currentQueueId = _d.currentQueueId, currentQueueName = _d.currentQueueName;
                    job.selectedFeedback = (0, util_1.getFeedbackIdsForJob)(job, feedbackSetArray);
                    job.isPostReviewed = isPostReviewEnabled && job.isDecisionMade;
                    jobDetailPromise = populateJobDetails(domain, job, currentQueueName || '');
                    return [2 /*return*/, { availableQueues: availableQueues, currentQueueId: currentQueueId, currentQueueName: currentQueueName, job: job, jobDetailPromise: jobDetailPromise }];
                case 2:
                    ex_1 = _e.sent();
                    return [2 /*return*/, { error: ex_1 }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.fetchAndPopulateItem = fetchAndPopulateItem;
function populateModerationNotes(domain, job, currentQueueName) {
    return __awaiter(this, void 0, void 0, function () {
        var ad, notes, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ad = job.ad;
                    if (!ad)
                        return [2 /*return*/];
                    job.currentQueueName = currentQueueName;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, moderationNotes_1.fetchModerationNotes)(domain, ad)];
                case 2:
                    notes = _a.sent();
                    job.moderationNotes = __assign(__assign({}, job.moderationNotes), { notes: notes, failedToLoad: false, loading: false });
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    job.moderationNotes = __assign(__assign({}, job.moderationNotes), { notes: [], failedToLoad: true, loading: false });
                    console.error('Error getting moderation notes', e_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.populateModerationNotes = populateModerationNotes;
function populateDuplicateCounts(domain, job) {
    return __awaiter(this, void 0, void 0, function () {
        var ad, remoteId, dedupHash, duplicatesCounts, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ad = job.ad;
                    if (!ad)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    remoteId = ad.remoteId.id || '';
                    dedupHash = ad.dedupHash || '';
                    return [4 /*yield*/, (0, duplicateAdsCount_1.getDuplicateAdsCount)(domain, [{ remoteId: remoteId, dedupHash: dedupHash }])];
                case 2:
                    duplicatesCounts = _a.sent();
                    job.duplicatesCount = duplicatesCounts && duplicatesCounts[remoteId] ? duplicatesCounts[remoteId] : 0;
                    return [3 /*break*/, 4];
                case 3:
                    e_3 = _a.sent();
                    job.hasErrorLoadingDuplicates = true;
                    console.error('Error getting duplicates count', e_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.populateDuplicateCounts = populateDuplicateCounts;
